module.exports = __webpack_public_path__ + "static/img/qnstatus7.85a878b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/qnstatus7.png
// module id = 369
// module chunks = 0